import { render, staticRenderFns } from "./graficas.vue?vue&type=template&id=988cb88a&scoped=true"
import script from "./graficas.vue?vue&type=script&lang=js"
export * from "./graficas.vue?vue&type=script&lang=js"
import style0 from "./graficas.vue?vue&type=style&index=0&id=988cb88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988cb88a",
  null
  
)

export default component.exports